export default "__VITE_ASSET__DYuJP4ab__"